import { TastingCard } from './TastingCard';

export type MoreFromVenueTasting = {
  id?: string;
  _id?: string;
  name: string;
  price: { amount: number; currency: string };
  duration?: number;
  requiresReservation?: boolean;
  wineClubOnly?: boolean;
};

interface MoreFromVenueProps {
  items: MoreFromVenueTasting[];
  currentExperienceId: string | undefined;
  venueName: string;
  venueHeroUrl: string | null;
  venuePolicy: 'required' | 'recommended' | 'drop-ins-welcome' | null;
}

/**
 * "More from [Winery]" strip on a tasting-experience detail page. Renders
 * nothing when the venue has no other tastings.
 */
export const MoreFromVenue = ({
  items,
  currentExperienceId,
  venueName,
  venueHeroUrl,
  venuePolicy,
}: MoreFromVenueProps) => {
  const siblings = items.filter((t) => (t.id ?? t._id) !== currentExperienceId);
  if (siblings.length === 0) return null;

  return (
    <div className="px-3 sm:px-0 mt-10">
      <h2 className="font-serif text-2xl font-normal text-gray-900 mb-4">
        More from {venueName}
      </h2>
      <div className="space-y-3">
        {siblings.slice(0, 5).map((t) => {
          const tastingId = (t.id ?? t._id) as string;
          const tastingData = {
            id: tastingId,
            name: t.name,
            price: t.price,
            duration: t.duration ?? null,
            requiresReservation: Boolean(t.requiresReservation),
            wineClubOnly: Boolean(t.wineClubOnly),
            heroImage: null,
          };
          return (
            <TastingCard
              key={tastingData.id}
              tasting={tastingData}
              venueHeroUrl={venueHeroUrl}
              venuePolicy={venuePolicy}
            />
          );
        })}
      </div>
    </div>
  );
};
